export default __webpack_public_path__ + "static/media/Yetunde.5c3860ee.png";